export default "__VITE_ASSET__9nFU7v2S__"